import { ALLOCATION_DISPLAY_DECIMAL_PLACES } from '@utils/allocationUnits';

export const ASSET_CLASS_GROUP_ROW_SX = {
  tableRow: {
    backgroundColor: 'action.hover',
  },
  expandCell: {
    padding: 0,
    textAlign: 'center',
  },
} as const;

// Matches Hephaestus Typography `bodySmall`.
export const BODY_SMALL_FONT_SIZE = '12px';

export const ALLOCATION_INPUT_STYLE = {
  fontSize: BODY_SMALL_FONT_SIZE,
  fontVariantNumeric: 'tabular-nums',
} as const;

export const ALLOCATION_PERCENT_FIELD_PROPS = {
  fullWidth: false,
  decimalPlaces: ALLOCATION_DISPLAY_DECIMAL_PLACES,
  trailingIcon: 'percent',
  showArrows: false,
  size: 'small',
  label: '',
  unsigned: true,
  textSize: BODY_SMALL_FONT_SIZE,
} as const;

export const ALLOCATION_AMOUNT_FIELD_PROPS = {
  fullWidth: false,
  size: 'small',
  label: '',
} as const;
